// extracted by mini-css-extract-plugin
export default {"cancelOrderButton":"styles_cancelOrderButton__KFqAi","fillButton":"styles_fillButton__YNwuu","buttonText":"styles_buttonText__+IlFI","canCancel":"styles_canCancel__7zYTH"};